<app-navbar [items]="navItems" [themes]="themes" [userObservable]="userObservable">
  <router-outlet></router-outlet>
</app-navbar>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/app.component.html